import React, { Component } from "react";
import LoginForm from "./LoginForm";
import * as Business from "../../utils/business";
import BgImg from "../../assets/images/login_bg.jpg";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
  }

  updateWindowDimensions() {
    if (this.refs.loginRef) {
      this.setState({ width: window.innerWidth, height: window.innerHeight });
      Business.setSizeScreen(window.innerWidth, window.innerHeight);
    }
  }

  render() {
    return (
      <div
        ref="loginRef"
        className="content"
        style={{ backgroundColor: "#f5f5f5", height: this.state.height }}
      >
        <div className="container-fluid" style={{ height: "100%" }}>
          <div className="row" style={{ height: "100%" }}>
            <div
              className="col-md-8 col-xs-0 d-none d-md-block"
              style={{
                height: "100%",
                position: "relative",
                background:
                  "linear-gradient(180deg, #0575E6 0%, #02298A 84.79%, #021B79 100%)",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundImage: `url(${BgImg})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div
              className="col-xs-12 col-md-4"
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0 32px",
              }}
            >
              <LoginForm
                onSubmit={(values) => {
                  this.props.onLogin && this.props.onLogin(values);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login/index.js